import { MouseEvent } from 'react';

import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { getPath, SETTINGS_SUBS_PATH } from 'constants/routes';
import { currentAccountSelector, isAccountOwnerSelector } from 'store/user/selectors';
import { confirmAlert } from 'utils/alert';

export function useUpgradeButton({ onClick: onClickCb }: { onClick?: () => void } = {}) {
  const history = useHistory();

  const isAccountOwner = useSelector(isAccountOwnerSelector);
  const currentAccount = useSelector(currentAccountSelector);

  const onClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (onClickCb) onClickCb();

    if (isAccountOwner) {
      history.push(getPath(SETTINGS_SUBS_PATH, { accountId: currentAccount.id }) + '#plan_tier_ii');
    } else {
      confirmAlert({
        title: 'Upgrade Your Account to Proceed',
        confirmButtonText: 'Contact Admin',
        hintBottom: 'Please contact your Account Administrator to upgrade your subscription plan.',
        showCancel: false,
        onConfirm: () => window.open(`mailto:${currentAccount.accountOwnerEmail}`),
      });
    }
  };

  return { onClick };
}
